export type BannerType =
  | "INTRODUCTION"
  | "LEARNING"
  | "QUESTIONS"
  | "HOME_ADS"
  | "PUBLIC_JOBS"
  | "FEED"
  | "GETTING_STARTED";

export type DisplayType = "MOBILE" | "DESKTOP";

export const BANNER_ASPECT_CLASSES: Record<BannerType, Record<DisplayType, string>> = {
  INTRODUCTION: { DESKTOP: "aspect-[1200/484]", MOBILE: "aspect-square" },
  LEARNING: { DESKTOP: "aspect-[1200/484]", MOBILE: "aspect-square" },
  QUESTIONS: { DESKTOP: "aspect-[1200/484]", MOBILE: "aspect-square" },
  FEED: { DESKTOP: "aspect-[1200/484]", MOBILE: "aspect-square" },
  HOME_ADS: { DESKTOP: "aspect-[12/5]", MOBILE: "aspect-square" },
  PUBLIC_JOBS: { DESKTOP: "aspect-[12/5]", MOBILE: "aspect-square" },
  GETTING_STARTED: { DESKTOP: "aspect-[12/5]", MOBILE: "aspect-square" },
};

export const BANNER_SIZES: Record<
  BannerType,
  { DESKTOP: string; MOBILE: string; note: string }
> = {
  INTRODUCTION:    { DESKTOP: "1200 × 484px", MOBILE: "640 × 640px", note: "Desktop ~2.48:1 • Mobile 1:1" },
  LEARNING:        { DESKTOP: "1200 × 484px", MOBILE: "640 × 640px", note: "Desktop ~2.48:1 • Mobile 1:1" },
  QUESTIONS:       { DESKTOP: "1200 × 484px", MOBILE: "640 × 640px", note: "Desktop ~2.48:1 • Mobile 1:1" },
  FEED:            { DESKTOP: "1200 × 484px", MOBILE: "640 × 640px", note: "Desktop ~2.48:1 • Mobile 1:1" },
  HOME_ADS:        { DESKTOP: "1200 × 500px", MOBILE: "800 × 800px", note: "Desktop 12:5 • Mobile 1:1" },
  PUBLIC_JOBS:     { DESKTOP: "1200 × 500px", MOBILE: "800 × 800px", note: "Desktop 12:5 • Mobile 1:1" },
  GETTING_STARTED: { DESKTOP: "1200 × 500px", MOBILE: "800 × 800px", note: "Desktop 12:5 • Mobile 1:1" },
};

export function getBannerSize(type: BannerType, display: DisplayType) {
  return BANNER_SIZES[type][display];
}

export const BANNER_COVER_HINT =
  "Use exatamente esta proporção. Mantenha textos e logos dentro de uma margem segura de 8% nas laterais.";
